var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("a-table", {
    staticClass: "marginT20",
    attrs: {
      bordered: "",
      columns: _vm.columns,
      "data-source": _vm.data,
      rowKey: "id"
    },
    scopedSlots: _vm._u([{
      key: "content",
      fn: function (text, record) {
        return [_c("a-tooltip", {
          attrs: {
            title: record.content
          }
        }, [_c("span", {
          staticClass: "message-content"
        }, [_vm._v(_vm._s(record.content))])])];
      }
    }, {
      key: "action",
      fn: function (text, record) {
        return [_c("a-button", {
          attrs: {
            type: "edit"
          },
          on: {
            click: function ($event) {
              return _vm.editScene(record);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("编辑")))])];
      }
    }])
  }, _vm._l(_vm.columns, function (item, i) {
    var _item$slots, _item$slots2, _item$slots3;
    return _c("span", {
      key: i,
      attrs: {
        slot: (_item$slots = item.slots) === null || _item$slots === void 0 ? void 0 : _item$slots.title
      },
      slot: (_item$slots2 = item.slots) === null || _item$slots2 === void 0 ? void 0 : _item$slots2.title
    }, [_vm._v(_vm._s(_vm.$t((_item$slots3 = item.slots) === null || _item$slots3 === void 0 ? void 0 : _item$slots3.title)))]);
  }), 0)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };